// extracted by mini-css-extract-plugin
export var alertIcon = "_pe-0";